

<template lang="html">
  <div>
    <template>
      <div>
        <div class="vx-card nexteventheader_div">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <p class="">
                Manage Event
                <feather-icon
                  icon="DownloadCloudIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-5"
                  title="Export Invitee List"
                  @click="activePrompt=true"
                />
              </p>
            </div>
            <vs-button @click="$router.push({ path: '/admin/dashboard' })" class='float-right'>Back</vs-button>
          </div>
        </div>
      </div>
      
      <vx-card code-toggler>
        <vs-tabs>
          <vs-tab label="Invited Users" icon-pack="feather" icon="icon-home">
						<div v-if='show.invitee_table' class="tab-text"> 
              </br>
              <template v-if='$store.getters.isRealAdmin'>
								<vs-row vs-type="flex" vs-w="12">
									<vs-col vs-type="flex" vs-w="8">
										<vs-input class="inputx" @input='urlTyping' :placeholder="$t('DestinationUrl')" v-model="destination_url"/>
										<vs-button @click.prevent="moveUserConfirm=true" :disabled="destination_url==null || destination_url==''" class="attendBtn float-right ml-2">{{ $t('MoveAttendants') }}</vs-button>
									</vs-col>
									<vs-col vs-type="flex" vs-w="2">
										<vs-button  @click="handleAttendents()" class="attendBtn">{{ $t('AddBulkAttendants')}}</vs-button>
									</vs-col>
                  <vs-col vs-type="flex" vs-w="2">
										<vs-button @click="Object.assign(show,{add_attendant_users:true,invitee_table:false,invitees_preview_config:true})" class="ml-1 attendBtn">{{ $t('AddAttendants')}}</vs-button>
									</vs-col>
								</vs-row>
              	<br/><br/><br/>
							</template>

              <vs-table search max-items="10" pagination :data="users">
                <template slot="thead">
                  <vs-th>
				            <vs-checkbox @change.stop="selectAttendants('all')" v-model="selectAllAttendants" style="display: inline-flex;margin-left:20px;" />
			            </vs-th>
                  <vs-th sort-key="first_name">First Name</vs-th>
                  <vs-th sort-key="last_name">Last Name</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th sort-key="id_number">Id Number</vs-th>
                  <vs-th sort-key="mobile_number">Mobile Number</vs-th>
                  <vs-th sort-key="is_rsvp">RSVP</vs-th>
                  <vs-th sort-key="is_attending">Attendance</vs-th>
                  <vs-th sort-key="weight">Weight</vs-th>
                  <vs-th sort-key="delegated_for">Delegate For</vs-th>
                  <vs-th sort-key="is_moderator">Moderator</vs-th>
                  <vs-th sort-key="is_speaker">Speaker</vs-th>
                  <vs-th sort-key="online_status">Online?</vs-th>
                  <vs-th>Browser</vs-th>
                  <vs-th>Current Page?</vs-th>
                  <vs-th>Actions</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <vs-checkbox @change.stop="selectAttendants('single')" v-model="tr.selected" style="display: inline-flex;margin-left:20px;" />
                    </vs-td>
                    <vs-td :data="data[indextr].first_name">{{ data[indextr].first_name }}</vs-td>
                    <vs-td :data="data[indextr].last_name">{{ data[indextr].last_name }}</vs-td>
                    <vs-td :data="data[indextr].email">
                      <a :href="'mailto:'+data[indextr].email">{{ data[indextr].email }}</a> 
                    </vs-td>
                    <vs-td :data="data[indextr].id_number">{{ data[indextr].id_number }}</vs-td>
                    <vs-td :data="data[indextr].mobile_number">{{ data[indextr].mobile_number }}</vs-td>
                    <vs-td :data="data[indextr].is_rsvp">
                      <vs-chip :color="getColor(data[indextr].is_rsvp)">
                        {{ data[indextr].is_rsvp == '1' ? 'Submitted' : 'Not submitted' }}
                      </vs-chip>
                    </vs-td>
                    <vs-td :data="data[indextr].is_attending">
                      <vs-chip :color="getColor(data[indextr].is_attending)">
                        {{ data[indextr].is_attending == '1' ? 'Attending' : 'Not Attending' }}
                      </vs-chip>
                    </vs-td>
                    <vs-td :data="data[indextr].weight">
                      <a @click="openWeightPopup(data[indextr].id)" style="cursor: pointer;">
                        Voting Weight
                      </a>
                    </vs-td>
                    <vs-td :data="data[indextr].delegated_for">
                      <div v-if="delegates[data[indextr].id] && delegates[data[indextr].id].length > 0">
                        <span @click="openDelegatePopup(data[indextr].id)" style="cursor: pointer;">
                          <span>{{
                              (delegates[data[indextr].id] && delegates[data[indextr].id].length > 0) ? delegates[data[indextr].id].length : '0'
                            }}</span>
                        </span>
                      </div>
                      <div v-else>0</div>
                    </vs-td>
                    <vs-td>{{ tr.is_moderator==1?'Yes':'No' }}</vs-td>
                    <vs-td>{{ tr.is_speaker==1?'Yes':'No' }}</vs-td>
                    <vs-td>
                      <span style="display: inline-flex">
                        <vs-icon :style="{color:isOnline(tr.online_status)?'green':'red','padding-right':'5%'}" icon="fiber_manual_record"></vs-icon>
                        {{ tr.online_status }} <template v-if='isOnline(tr.online_status)'>({{tr.online_count }})</template>
                      </span>
                    </vs-td>
                    <vs-td>
                      <template v-if='isOnline(tr.online_status)'>
                        {{ tr.visited_pages_ | browsers }}
                      </template>
                      <template v-else>-</template>
                    </vs-td>
                    <vs-td>
                      <span v-if='isOnline(tr.online_status)' v-html='filter_visited_pages(tr.visited_pages_)'></span>
                      <span v-else>-</span>
                    </vs-td>
                    <vs-td>
                      <router-link
												class="mb-2 mr-1"
												type="filled"
												color="primary"
                        :to="{name: 'ViewUser', params: {id: tr.id}}"
											>
                        <vs-button class="run_btn" color="success" type="filled">View details</vs-button>
                      </router-link>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
            <div class="tab-text" v-if='show.download_sample'>
              <h4>Import contact :</h4>
              <br/>
              <p>Prepare excel document with following format :</p>
              <div class="vx-row">
                <vs-table :data="sampleusers" class="vx-col md:w-1/2 w-full mt-5">
                  <template slot="thead">
                    <vs-th>First Name</vs-th>
                    <vs-th>Last Name</vs-th>
                    <vs-th>Id Number</vs-th>
                    <vs-th>Email</vs-th>
                    <vs-th>Mobile Number</vs-th>
                    <vs-th>Delegated For</vs-th>
                    <vs-th>Weight</vs-th>
                    <vs-th>Moderator</vs-th>
                    <vs-th>Speaker</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].first_name">{{ data[indextr].first_name }}</vs-td>
                      <vs-td :data="data[indextr].last_name">{{ data[indextr].last_name }}</vs-td>
                      <vs-td :data="data[indextr].id_number">{{ data[indextr].id_number }}</vs-td>
                      <vs-td :data="data[indextr].email">{{ data[indextr].email }}</vs-td>
                      <vs-td :data="data[indextr].mobile_no">{{ data[indextr].mobile_no }}</vs-td>
                      <vs-td :data="data[indextr].delegated_for">{{ data[indextr].delegated_for }}</vs-td>
                      <vs-td :data="data[indextr].weight">{{ data[indextr].weight }}</vs-td>
                      <vs-td :data="data[indextr].is_moderator">{{ data[indextr].is_moderator }}</vs-td>
                      <vs-td :data="data[indextr].is_speaker">{{ data[indextr].is_speaker }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-button class="float-right" @click="handleSample">DOWNLOAD THE SAMPLE</vs-button>
                </div>
                <br/>
                <br/>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-full w-full mt-5">
                  <vs-button class="float-right" @click="handleContinue">CONTINUE</vs-button>
                </div>
              </div>
            </div>
            <div v-if='show.invitees_preview_config || show.upload_invitees || show.add_attendant_users' class="tab-text">
              
							<template v-if='show.upload_invitees'>
                <h4>Upload File :</h4>
                <br/>
                <div class="mb-8">
                  <import-excel :onSuccess="loadDataInTable"/>
                </div>
              </template>

              <template v-if='show.invitees_preview_config'>
                <div>
                  <h4 style="display: inline;vertical-align: top;">Configure notifications:</h4>
                  <vs-checkbox v-model="checkbox_sms_enabled" style="display: inline-flex;margin-left:20px;">SMS
                  </vs-checkbox>
                  <vs-checkbox v-model="checkbox_email_enabled" style="display: inline-flex;margin-left:20px;">Email
                  </vs-checkbox>
									<template v-if='!show.add_attendant_users'>
										<vs-checkbox v-model="checkbox_update_mobile_enabled" style="display: inline-flex;margin-left:20px;">Update Users mobile number
										</vs-checkbox>
										<vs-checkbox v-model="checkbox_update_email_enabled" style="display: inline-flex;margin-left:20px;">Update users Email
										</vs-checkbox>
									</template>
                </div>
                
								<add-attendant-users @update='addAttendants' v-if='show.add_attendant_users' :event='eventDetails' :attendees='users'></add-attendant-users>

                <vs-table
									v-else
                  multiple
                  v-model="selected"
                  pagination
                  :max-items="100"
                  search
                  :data="tableData"
                >
                  <template slot="header">
                    <h4>Invitees :</h4>
                  </template>

                  <template slot="thead">
                    <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td
                        v-for="heading in header"
                        :key='heading'
                      >{{ tr[heading] }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <br/>
                <div class="float-right">
                  <span
                    style="margin-right:15px;"
                  >Do you want to send {{ selected.length }} invites via email?</span>
                  <vs-button @click="handleInvitation">Confirm</vs-button>
                </div>
                <br/>
                <br/>
              </template>
              
            </div>

            <div class="tab-text" v-if='show.invites_success'>
              <div class="vx-row">
                <div class="vx-col w-full mb-3">
                  <h4>Sending invitation</h4>
                  <br/>
                  <p>we will be sending {{ selected.length }} invites to your event shortly</p>
                  <br/>
                  <vs-progress class="block mt-1" :percent="percent_completed" color="primary"></vs-progress>
                  <br/>
                  <div class="success-msg" style="color:green;display:none">
                    <span>Invitations sent successfully!!</span>
                    <vs-button class="float-right" @click="back">Go to Manage Event</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </vs-tab>
          <vs-tab v-if='$store.getters.isRealAdmin' label="Add Voting" icon-pack="feather" icon="icon-box">
            <div class="tab-text"><br>
              <voting-form :start-date='eventDetails.event_start_date' :end-date='eventDetails.event_end_date' :vote='votingArray' v-bind:validator.sync='validators.$addVote'>
                <br/>
                <div class="upload-file">
                  <label>Upload File</label>
                  <div>
                    <div class="mb-8">
                      <import-excel :onSuccess="loadDataInTable1"/>
                    </div>
                    <div v-if="votingData.length && header.length">
                      <vs-table
                        multiple
                        v-model="selectedForVoting"
                        pagination
                        :max-items="100"
                        search
                        :data="votingData"
                      >
                        <template slot="header">
                          <h4>Invitees :</h4>
                        </template>

                        <template slot="thead">
                          <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td
                              v-for="heading in header" :key="heading"
                            >{{ tr[heading] }}
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                      <br/>
                    </div>
                  </div>
                </div>
                <br>
                <vs-button button='submit' class="attendBtn float-right" @click.prevent.stop="addVoting()">Submit</vs-button>
              </voting-form>
            </div>
          </vs-tab>
          <vs-tab v-if='$store.getters.isRealAdmin' label="Edit Voting" icon-pack="feather" icon="icon-mail">
            <div class="tab-text">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <label>Select Voting to update:</label>
                  <vs-select v-model="votingSelected"
                             class="w-full select-large voting-dropdown"
                             @input="loadVotingDetails()" :disabled="votingSelectDisabled">
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.voting_name"
                      v-for="(item,index) in eventDetails.event_voting"
                      class="w-full"
                    />
                  </vs-select>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-10">
                  <vs-button @click="resetEditForm()" class="attendBtn">Clear</vs-button>
                </div>
              </div>
              <voting-form v-if='showEditForm' :validator.sync='validators.$editVote' :is-update='true' :start-date='eventDetails.event_start_date' :end-date='eventDetails.event_end_date' :vote='editVotingArray' form-scope='editVoting'>
                <br/>
                <div class="upload-file">
                  <label>Upload File</label>
                  <div>
                    <div class="mb-8">
                      <import-excel :onSuccess="loadDataInTable2"/>
                    </div>
                    <div v-if="updateVotingData.length && header.length">
                      <vs-table
                        multiple
                        v-model="selectedForUpdateVoting"
                        pagination
                        :max-items="100"
                        search
                        :data="updateVotingData"
                      >
                        <template slot="header">
                          <h4>Invitees :</h4>
                        </template>

                        <template slot="thead">
                          <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td
                              v-for="heading in header" :key="heading"
                            >{{ tr[heading] }}
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                      <br/>
                    </div>
                  </div>
                </div>
                <br/>
                <br/>
                <div class="upload-candidates-file" v-if="editVotingArray.type_of_voting === 4">
                  <label>Upload Candidates File</label>
                  <div>
                    <div class="mb-8">
                      <import-excel :onSuccess="loadDataInTable3"/>
                    </div>
                    <div v-if="updateCandiatesData.length && header.length">
                      <vs-table
                        multiple
                        v-model="selectedForUpdateCandidates"
                        pagination
                        :max-items="100"
                        search
                        :data="updateCandiatesData"
                      >
                        <template slot="header">
                          <h4>Candidates :</h4>
                        </template>

                        <template slot="thead">
                          <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td
                              :data="col"
                              v-for="(col, indexcol) in data[indextr]"
                              :key="indexcol + col"
                            >{{ col }}
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                      <br/>
                    </div>
                  </div>
                  <vs-button @click="importCandidatesArray()" class="attendBtn float-right">Import</vs-button>
                </div>

                <br>
                <br>
                <br>
                <vs-button @click.prevent.stop='updateVoting()' button='submit' class="attendBtn float-right">Submit</vs-button>
              </voting-form>
            </div>
          </vs-tab>
          <!--          </vs-tab>-->
          <!--<vs-tab label="SMS and Email Configuration" icon-pack="feather" icon="icon-mail">
            <div class="tab-text">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <label>Select configuration to update:</label>
                    <vs-select v-model="configTypeSelected"
                    class="w-full select-large voting-dropdown"
                    @change="onConfigSelected()">
                      <vs-select-item
                        :key="index"
                        :value="item.id"
                        :text="item.title"
                        v-for="(item,index) in configTypes"
                        class="w-full"
                      />
                    </vs-select>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-10">
                  <vs-button @click="updateConfig()" class="updateConfigBtn">Save</vs-button>
                </div>
              </div>
                <div class="eventSmsEmailBlock" v-if="showEventSmsEmailBlock">
                    <div v-if="configType == 2">
                    <vs-input v-model="configSubject" class="w-full"/>
                  </div>
                  <div v-if="configType == 2">
                      <ckeditor v-model="configBody"></ckeditor>
                  </div>
                  <div v-else>
                      <vs-textarea  v-model="configBody" rows="10" style="width:100%; height: auto;" />
                  </div>
                </div>
            </div>
          </vs-tab>-->
        </vs-tabs>
      </vx-card>
    </template>
    <!-- Popup Code -->
    <vs-popup class="holamundo" title="Weights" :active.sync="weightsPopupActive">
      <vs-table max-items="10" pagination :data="userWeightData">
        <template slot="thead">
          <vs-th>Voting Name</vs-th>
          <vs-th>Weight</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].voting_name">{{ data[indextr].voting_name }}</vs-td>
            <vs-td :data="data[indextr].weight">{{ data[indextr].weight }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!-- Popup Code -->
    <!-- Popup Code -->
    <vs-popup class="holamundo" title="Delegated For" :active.sync="delegatePopupActive">
      <vs-table max-items="10" pagination :data="userDelegateData">
        <template slot="thead">
          <vs-th>First Name</vs-th>
          <vs-th>Last name</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].fname">{{ data[indextr].fname }}</vs-td>
            <vs-td :data="data[indextr].lname">{{ data[indextr].lname }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!-- Popup Code -->
		

    <vs-prompt :active.sync="moveUserConfirm" :title="$t('ConfirmYourDecision')" :accept-text="$t('Confirm')" :cancel-text="$t('Cancel')" @accept="changeUserCurrentUrl">
      {{$t('YouAreMoving')}} {{ no_of_user_not_on_page }} {{ $t('usersTo') }}:<br>{{ windowUrl + destination_url }}
    </vs-prompt>

    <vs-prompt title="Export To Excel" class="export-options" @cancel="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
        <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full"/>
        <v-select v-model="selectedFormat" :options="formats" class="my-4"/>
        <div class="flex">
          <span class="mr-4">Cell Auto Width:</span>
          <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
        </div>
      </vs-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import $ from "jquery";
import ImportExcel from "@/components/excel/ImportExcel.vue";
import {Validator} from "vee-validate";
import {connect} from 'tls';
import { UAParser } from 'ua-parser-js';
import AddAttendantUsers from '@/views/components/add-attendant-users';
import VotingForm from './VotingForm.vue';

const OnlineStatus = {
  offline: 'Offline',
  online: 'Online'
};

const dict = {
  messages: {
    required: () => 'This field is required'
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
	components: {
    ImportExcel,
    vSelect,
		AddAttendantUsers,
    VotingForm
  },
  data: () => ({
    validators: {
      $addVote: null,
      $editVote: null
    },
    selectAllAttendants: false,
    show: {
      upload_invitees: false,
      invitees_preview_config: false,
      download_sample: false,
			invites_success: false,
			invitee_table: true,
    	add_attendant_users: false,
    },
		windowUrl: "",
    activePrompt: false,
    fileName: '',
    // formats:['xlsx', 'csv', 'txt'],
    formats: ['xlsx'],
    cellAutoWidth: true,
    selectedFormat: 'xlsx',
    headerTitle: ['First Name', 'Last Name', 'Email', 'Mobile Number', 'RSVP', 'Attendance', 'Weight', 'Delegate For'],
    headerVal: ['first_name', 'last_name', 'email', 'mobile_number', 'is_rsvp', 'is_attending', 'weight', 'delegate_for'],
    users: [{}],
    sampleusers: [
      {
        first_name: "Mario",
        last_name: "Rossi",
        id_number: 9931314,
        email: "mario@ex.com",
        mobile_no: "347 7777777",
        delegated_for: "77931314",
        weight: "1",
        is_speaker: '1',
        is_moderator: '0'
      },
      {
        first_name: "Lusia",
        last_name: "Bianchi",
        id_number: 77931314,
        email: "lusia@ex.com",
        mobile_no: "347 888888",
        weight: "0",
        is_speaker: '1',
        is_moderator: '1'
      },
      {
        first_name: "Alex",
        last_name: "Bianchi",
        id_number: 77931314,
        email: "alex@ex.com",
        mobile_no: "347 888898",
				delegated_for: "77931315",
        weight: "0",
        is_speaker: '0',
        is_moderator: '0'
      }
    ],
    configdateTimePicker: {
      enableTime: true,
      dateFormat: 'Y-m-d h:i:s',
      minDate: null,
      maxDate: null,
      altInput: true,
      altFormat: 'F j, Y H:i'
    },
    percent_completed: 10,
    file: null,
    selected: [],
    event_id: "",
    tableData: [],
    header: [],
    sheetName: "",
    votingArray: {
      event_id: "",
      voting_name: "",
      voting_description: "",
      voting_start_date: "",
      voting_end_date: "",
      opening_mode: "manual",
      type_of_voting: "1",
      quorum_type: "1",
      is_secret: "0",
      candidate_number: 1,
      preference_no: 1,
      min_preference_no: 1,
      number_of_candidates_elect: 1,
      option_number: 2,
      candidates: [{
				candidate_name: '',
				candidate_surname: '',
				is_checkbox: 0,
        is_button: 0,
			}],
			timer_: {
				minutes: '00',
				seconds: '00'
			},
			get timer() {
				return this.timer_.minutes + ':' + this.timer_.seconds
			},
      options: [{option: '', is_enabled: true},{option: '', is_enabled: true}]
    },
    openingMode: [{text: "Manual", value: "manual"}],
    typeOfSecret: [{text: "Secret", value: "1"}, {text: "NonSecret", value: "0"}],
    eventDetails: {},
    selectedForVoting: [],
    votingData: [],
    updateVotingData: [],
    updateCandiatesData: [],
    selectedForUpdateVoting: [],
    selectedForUpdateCandidates: [],
    editVotingArray: {
      id: "",
      voting_name: "",
      voting_description: "",
      voting_start_date: "",
      voting_end_date: "",
      opening_mode: "manual",
      type_of_voting: "1",
      quorum_type: "1",
      is_secret: "0",
      candidate_number: 1,
      min_preference_no: 1,
      preference_no: 1,
      number_of_candidates_elect: 1,
      option_number: 2,
      candidates: [{
				candidate_name: '',
				candidate_surname: '',
				is_checkbox: 0,
        is_button: 0,
			}],
			timer_: {
				minutes: '00',
				seconds: '00'
			},
			get timer() {
				return this.timer_.minutes + ':' + this.timer_.seconds
			},
      options: [{options: '', is_enabled: true},{options: '', is_enabled: true}]
    },
    votingSelected: '',
    votingList: [],
    votingSelectDisabled: false,
    showEditForm: false,
    weightsPopupActive: false,
    weightData: [],
    userWeightData: [],
    delegates: [],
    delegatePopupActive: false,
    userDelegateData: [],
    configTypes: [],
    configTypeSelected: '',
    configSubject: '',
    configBody: '',
    configType: '',
    showEventSmsEmailBlock: false,
    checkbox_sms_enabled: true,
    checkbox_email_enabled: true,
    checkbox_update_mobile_enabled: false,
    checkbox_update_email_enabled: false,
    inviteeDelegates: [],
    exportInvitees: [],
		destination_url: '',
		moveUserConfirm: false,
  }),
  computed: {
    no_of_user_not_on_page() {
      const destination_url = this.destination_url;
      return this.users.filter(user => user.online_count>0 && user.visited_pages_ && user.visited_pages_.findIndex(vp => vp.last_visited_page==destination_url)==-1).length;
    }
  },
  filters: {
    visited_pages: function(visited_pages) {
      return visited_pages.map(vp => vp.last_visited_page).join('<br/>');
    },
    browsers: function(visited_pages) {
      return visited_pages.map(vp => vp.browser_name).join('\n');
    }
  },
  // watch: {
  //   'votingArray.type_of_voting': function(nt, ot){
  //     if(ot == 1 && nt == 4)
  //       this.candidatesInt = this.votingArray.candidate_number;
  //     else if(ot == 4 && nt == 1)
  //       this.votingArray.candidate_number = this.candidatesInt;
  //   },
  //   'editVotingArray.type_of_voting': function(nt, ot){
  //     if(ot == 1 && nt == 4){
  //       this.candidatesInt = this.editVotingArray.candidate_number == null ? this.editVotingArray.candidates.length : this.editVotingArray.candidate_number;
  //     }
  //     else if(ot == 4 && nt == 1) {
  //       this.editVotingArray.candidate_number = this.candidatesInt;
  //     }
  //   }
  // },
  async mounted() {
		this.windowUrl = window.location.origin;
    this.getConfigTypes()
    this.getEventDetails()
    this.getVotingTypes()
    await this.getEventUsers()

    const me = this;
    window.Echo.join('useractive')
    .here(user_infos => {
      me.users = me.users.map(user => {
        const ousers = user_infos.filter(ui => ui.user_id == user.id);

        user.online_count = ousers.length;
        user.online_status = user.online_count > 0 ? OnlineStatus.online : OnlineStatus.offline;
        const visited_pages = user.visited_pages
        .map(vp => {
          const ouser = ousers.find(ouser => ouser.browser_identifier == vp.browser_identifier);
          return ouser
            ? me.mapVisitedPages(Object.assign({user_agent:ouser.user_agent}, vp))
            : null;

        }).filter(vp => vp !== null);

        me.$set(user, 'visited_pages_', visited_pages);
        return user;
      });
    })
    .joining(user_info => {
      const user = me.users.find(user => user.id==user_info.user_id);
      if(user){
        user.online_status = OnlineStatus.online
        user.online_count++;

        let visited_page = user.visited_pages.find(vp => vp.browser_identifier == user_info.browser_identifier)

        if(!visited_page) {
          visited_page = {
            browser_identifier: user_info.browser_identifier,
            last_visited_page: '/',
          }
          user.visited_pages.push(visited_page);
        }

        if(visited_page) {
          user.visited_pages_.push(
            me.mapVisitedPages(
              Object.assign({user_agent:user_info.user_agent}, visited_page)
            )
          );
        }
      }
    })
    .leaving(user_info => {

      const user_idx = me.users.findIndex(user => user.id==user_info.user_id);

      if(user_idx > -1){
        const user = me.users[user_idx];
        user.online_count--;

        const vp_idx = user.visited_pages_.findIndex(vp=>vp.browser_identifier == user_info.browser_identifier);
        if(vp_idx > -1)
          user.visited_pages_.splice(vp_idx, 1);
        user.online_status = user.online_count > 0 ? OnlineStatus.online : OnlineStatus.offline;
      }
    });

    window.Echo.private('userLastVisited')
    .listen('UserLastVisited', response => {
      const user = me.users.find(user => user.id==response.data.user_id);

      if(user) {
        const vp = user.visited_pages_.find(vp=>response.data.browser_identifier == vp.browser_identifier);

        if(vp)
          vp.last_visited_page = response.data.last_visited_page;

      }

    });
  },
  created() {
    this.event_id = this.$route.params.id;
  },
  beforeDestroy() {
    window.Echo.leave('useractive');
    window.Echo.leave('userLastVisited')
  },
  methods: {
    urlTyping(e) { 
      if(e && e.charAt(0) != '/')
        this.destination_url = '/'+this.destination_url;
    },
		changeUserCurrentUrl() {
			this.$vs.loading();
			const selectedUsers = this.users.filter(user => user.selected).map(user => user.id);
      
			var formData = new FormData();
			formData.append("new_page", this.destination_url);
			formData.append("users", JSON.stringify(selectedUsers));
      this.$store
        .dispatch("changeUserCurrentUrl", formData)
        .then((response) => {
          this.$vs.loading.close();
					this.moveUserConfirm = false;
					this.destination_url = '';
        })
        .catch((error) => {
          this.$log.error(
            "File : EventUsers.vue | Function : changeUserCurrentUrl() | Error :",
            error
          );
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to redirect",
            text: error,
            color: "danger",
            position: "top-center",
          });
          return false;
        });
    },
    filter_visited_pages(visited_pages) {
      return visited_pages.map(vp => vp.last_visited_page).join('<br/>');
    },
    isOnline(online_status) {
      return OnlineStatus.online == online_status;
    },
    mapVisitedPages(vp) {
      if(vp.user_agent) {
        const uaparser = new UAParser(vp.user_agent);
        const browser = uaparser.getBrowser();
        vp.browser_name = browser.name + ' ' + browser.version;
      }
      return vp;
    },
    updateConfig() {
      let data = {"id": this.configTypeSelected, "subject": this.configSubject, "body": this.configBody};
      this.$vs.loading();
      this.$store
        .dispatch("UpdateEventSmsEmailConfig", data)
        .then(response => {
          this.getConfigTypes()
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Cofiguration changed successfully ",
            color: "success",
            position: "top-center"
          });
        })
        .catch(error => {
          this.$log.error('File : Settings.vue | Function : saveConfigData() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to update Cofiguration",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    onConfigSelected() {
      this.showEventSmsEmailBlock = true;
      this.configTypes.forEach((config, index) => {
        if (config.id == this.configTypeSelected) {
          this.configSubject = config.subject;
          this.configBody = config.body;
          this.configType = config.type;
        }
      })
    },
    getConfigTypes() {
      this.$vs.loading();
      this.$store
        .dispatch("GetEventSmsEmailConfig", this.event_id)
        .then(response => {
          this.configTypes = response.data.data;
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : EventUsers.vue | Function : getConfigTypes() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to load data",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    openWeightPopup(userId) {
      this.weightsPopupActive = true;
      this.userWeightData = this.weightData[userId];
    },
    openDelegatePopup(userId) {
      this.delegatePopupActive = true;
      this.userDelegateData = this.delegates[userId];
    },
		addAttendants(results) {
			// this.header = ["First Name","Last Name","Id Number","Email","Mobile Number","Delegated For","Weight","Moderator?","Speaker?"];
			this.selected = results.map(r => ({
				"First Name":r.first_name,
				"Last Name":r.last_name,
				"Id Number":r.id_number,
				"Email":r.email,
				"Mobile Number":r.mobile_number,
				"Delegated For":"",
				"Weight":r.weight,
				"Moderator?":r.is_moderator?"Yes":"No",
				"Speaker?":r.is_speaker?"Yes":"No"
			}));
		},
    loadDataInTable({results, header, meta}) {
      this.show.invitees_preview_config = true;
      this.header = header;
      this.tableData = this.selected = results;
      this.sheetName = meta.sheetName;
    },
    loadDataInTable1({results, header, meta}) {
      this.header = header;
      this.votingData = this.selectedForVoting = results;
      this.sheetName = meta.sheetName;
    },
    loadDataInTable2({results, header, meta}) {
      this.header = header;
      this.updateVotingData = this.selectedForUpdateVoting = results;
      this.sheetName = meta.sheetName;
    },
    loadDataInTable3({results, header, meta}) {
      this.header = header;
      this.updateCandiatesData = this.selectedForUpdateCandidates = results;
      this.sheetName = meta.sheetName;
    },
    selectedFile(event) {
      this.file = event.target.files[0];
    },
    handleAttendents() {
      this.show.invitee_table = false;
      this.show.download_sample = true;
    },
    handleSample() {
      this.$vs.loading();
      this.$store
        .dispatch("downloadFile")
        .then(res => {
          this.$vs.loading.close();
          var data = res.data;
          // Success response
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "symposium_invitation_template.xlsx"
          );
          document.body.appendChild(fileLink);

          fileLink.click();

          this.$vs.notify({
            color: "success",
            title: "Download Success",
            text: "File downloaded successfully!!",
            position: "top-center"
          });
        })
        .catch(error => {
          this.$log.error('File : EventUsers.vue | Function : handleSample() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to download file, please try again",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    handleContinue() {
      this.show.download_sample = false;
      this.show.upload_invitees = true;
    },
    increase() {
      this.percent_completed = this.percent_completed + 10;
    },
    configureNotifications(notificationdata) {
      this.$store.dispatch("SmsEmailEventSetting", Object.assign({}, notificationdata))
        .then((res) => {
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$vs.loading.close();
        });
    },
    async handleInvitation() {
      let checkbox_email_enabled = 0;
      let checkbox_sms_enabled = 0;
      let checkbox_update_mobile_enabled = 0;
      let checkbox_update_email_enabled = 0;
      if (this.checkbox_email_enabled) checkbox_email_enabled = 1;
      if (this.checkbox_sms_enabled) checkbox_sms_enabled = 1;
      if (this.checkbox_update_email_enabled) checkbox_update_email_enabled = 1;
      if (this.checkbox_update_mobile_enabled) checkbox_update_mobile_enabled = 1;
      let notificationdata = {
        "event_id": this.event_id,
        "is_enabled": checkbox_email_enabled,
        "is_sms_enabled": checkbox_sms_enabled
      };
      this.configureNotifications(notificationdata);
      if(this.selected.length < 1)
        return false;
      this.show.invites_success = true;
			this.show.add_attendant_users = this.show.invitees_preview_config = false;
      const percent = setInterval(() => {
        this.increase();
      }, 1000);

      const selected = this.selected.map(_item => 
        ({
          email: `${_item['Email']}`.trim(),
          first_name: `${_item['First Name']}`.trim(),
          last_name: `${_item['Last Name']}`.trim(),
          id_number: `${_item['Id Number']}`.trim(),
          mobile_number: `${_item['Mobile Number']}`.trim(),
          weight: `${_item['Weight']}`.trim() || `${_item['Right To Vote']}`.trim(),
          delegated_for: `${_item['Delegated For']}`.trim() || null,
          is_moderator: `${_item['Moderator?']}`.trim().toLowerCase()=='yes' ? 1 : 0,
          is_speaker: `${_item['Speaker?']}`.trim().toLowerCase()=='yes' ? 1 : 0,
          external_id: `${_item['External Id']}`.trim() || null
        })
      );

      var data = {
        event_id: this.event_id,
        users: selected,
        "update_email": checkbox_update_email_enabled,
        "update_mobile": checkbox_update_mobile_enabled,
      };
      try {
        await this.$store.dispatch("importUsers", data)
        this.percent_completed = 100;
        this.$vs.notify({
          color: "success",
          text: "Invitation sent successfully!!",
          position: "top-center"
        });
        $(".success-msg").show();
        clearInterval(percent);

      }catch (error) {
        // Error response
        this.$log.error('File : EventUsers.vue | Function : handleInvitation() | Error :', error);
        this.$vs.notify({
          title: "Failed to send invitation, please try again",
          text: error,
          color: "danger",
          position: "top-center"
        });
        return false;
      }
      
    },
    back() {
      this.$vs.loading();
      this.$store
        .dispatch("GetEventUsers", this.$route.params.id)
        .then(response => {
          this.$vs.loading.close();
          this.users = response.data.data.map(user => {
            // user.last_visited_page = [];
            user.selected = false;
            user.online_count = 0;
            return user;
          });

          this.show.invitee_table = true;
          this.show.invites_success = false;
          this.users.forEach((user) => {
            this.weightData[user.id] = user.voting_weights;
            this.delegates[user.id] = [];
            if (user.delegated_for.length > 0) {
              user.delegated_for.forEach((del, index) => {
                this.delegates[user.id].push({'fname': del.first_name, 'lname': del.last_name});
              })
            }
          })
        })
        .catch(error => {
          this.$log.error('File : EventUsers.vue | Function : back() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to load data",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    async getEventUsers() {
      this.$vs.loading();
      try{
        const response = await this.$store.dispatch("GetEventUsers", this.$route.params.id);

        this.users = response.data.data
        .map(user => {
          user.online_status = OnlineStatus.offline;
          user.online_count = 0;
          return user;
        });
        
        this.users.forEach((user) => {
          this.weightData[user.id] = user.voting_weights;
          this.delegates[user.id] = [];
          if (user.delegated_for.length > 0) {
            user.delegated_for.forEach((del, index) => {
              this.delegates[user.id].push({'fname': del.first_name, 'lname': del.last_name});
            })
          }
        });
        let singleDelegate = [];
        this.users.forEach((invitee) => {
          this.inviteeDelegates[invitee.id] = []
          singleDelegate[invitee.id] = [];
          if (invitee.delegated_for.length > 0) {
            invitee.delegated_for.forEach((inviteedel, index) => {
              singleDelegate[invitee.id].push(inviteedel.first_name + " " + inviteedel.last_name);
            })
            this.inviteeDelegates[invitee.id]["delegate_for"] = singleDelegate[invitee.id].join(", ");
          }
          this.inviteeDelegates[invitee.id]["first_name"] = invitee.first_name;
          this.inviteeDelegates[invitee.id]["last_name"] = invitee.last_name;
          this.inviteeDelegates[invitee.id]["email"] = invitee.email;
          this.inviteeDelegates[invitee.id]["mobile_number"] = invitee.mobile_number;
          this.inviteeDelegates[invitee.id]["is_rsvp"] = invitee.is_rsvp;
          this.inviteeDelegates[invitee.id]["is_attending"] = invitee.is_attending;
          this.inviteeDelegates[invitee.id]["weight"] = invitee.weight;
          if (this.inviteeDelegates.length > 0) {
            this.exportInvitees.push(this.inviteeDelegates[invitee.id]);
          }
        })
      }catch(e){
				console.log(e)
        this.$log.error('File : EventUsers.vue | Function : getEventUsers() | Error :', error);
        this.$vs.loading.close();
        // Error response
        this.$vs.notify({
          title: this.$t("FailedToLoadData"),
          text: error,
          color: "danger",
          position: "top-center"
        });
        return false;
      }
      this.$vs.loading.close();
      return true;
    },
    getColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
    },
    deleteEvent(id) {

      this.$swal({
        title: "Are you sure to start the event?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#7367F0",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();
          this.$store
            .dispatch("DeleteEvent")
            .then(response => {
              this.$vs.loading.close();
              this.events = response.data.data;
            })
            .catch(error => {
              this.$log.error('File : EventUsers.vue | Function : deleteEvent() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: "Failed to load data",
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      })

    },
    getVotingTypes() {

      // call store function
      this.$store
        .dispatch("GetVotingTypes")
        .catch(error => {
          this.$vs.loading.close();
          return false;
        });
    },
    async addVoting() {
			const result = await this.validators.$addVote.validateAll("voting-form");
			if(!result)
				return false

			this.$vs.loading()
			this.votingArray['event_id'] = this.event_id;

			try{
				const res = await this.$store.dispatch("addNewVoting", Object.assign({}, this.votingArray))

				this.$vs.loading.close()
				var data = res.data;
				if (data.data.id) {
					this.$vs.notify({
						color: "success",
						text: "Voting created successfully!!",
						position: "top-center"
					});
					this.getEventDetails();
					this.resetAddForm();
					this.handleAddVotingInvite(data.data.id);
				}
			}catch(error){
				this.$vs.loading.close()
				// Error response
				this.$vs.notify({
					title: "Failed to create voting, please try again",
					text: error,
					color: "danger",
					position: "top-center"
				});
			}
    },
    getEventDetails() {
      // call store function
      this.$store
        .dispatch("getOnlyEventDetails", this.event_id)
        .then((response) => {
          this.eventDetails = response.data.data.data;
          this.destination_url = '/event/' + this.eventDetails.slug;
          // this.$set(this.configdateTimePicker, 'minDate', this.eventDetails.event_start_date)
          // this.$set(this.configdateTimePicker, 'maxDate', this.eventDetails.event_end_date)
        })
        .catch(error => {
          this.$vs.loading.close();
          return false;
        });
    },
    importCandidatesArray() {
      this.editVotingArray.candidates = [];
      for (let cKey in this.selectedForUpdateCandidates) {
        this.editVotingArray.candidates.push({
          id: '',
          candidate_name: this.selectedForUpdateCandidates[cKey].name,
          candidate_surname: this.selectedForUpdateCandidates[cKey].surname,
          is_checkbox: 0,
          is_button: false
        })
      }
      this.selectedForUpdateCandidates = [];
    },
    /**
     * Import selected users
     * @author Madhura Shah
     */
    handleVotingInvite(selectedForVoting, voting_id) {
      if (selectedForVoting.length > 0) {

        selectedForVoting.forEach((element, index) => {
          element['email'] = element['Email'];
          element['first_name'] = element['First Name'];
          element['last_name'] = element['Last Name'];
          element['id_number'] = element['Id Number'],
            element['mobile_number'] = element['Mobile Number'] ? element['Mobile Number'] : null,
            element['weight'] = element['Weight'] !== undefined ? element['Weight'] : element['Right To Vote'],
            element['delegated_for'] = element['Delegated For'] ? element['Delegated For'] : null
          selectedForVoting[index] = element
        });

        var data = {
          event_voting_id: voting_id,
          users: selectedForVoting
        };
        this.$vs.loading()
        this.$store
          .dispatch("importVotingUsers", data)
          .then(() => {
            this.$vs.loading.close()
            this.selectedForUpdateVoting = [];
            this.$vs.notify({
              color: "success",
              text: "Invitation updated successfully!!",
              position: "top-center"
            });
          })
          .catch(error => {
            // Error response
            this.$vs.notify({
              title: "Failed to send invitation, please try again",
              text: error,
              color: "danger",
              position: "top-center"
            });
            return false;
          });
      } else {
        return false;
      }
    },
    handleVotingCandidates(selectedForUpdateCandidates, voting_id) {
      if (selectedForUpdateCandidates.length > 0) {

        selectedForUpdateCandidates.forEach((element, index) => {
          element['first_name'] = element['First Name'];
          element['last_name'] = element['Last Name'];
          selectedForUpdateCandidates[index] = element
        });

        var data = {
          event_voting_id: voting_id,
          users: selectedForUpdateCandidates
        };
        this.$vs.loading()
        this.$store
          .dispatch("importVotingCandidates", data)
          .then(() => {
            this.$vs.loading.close()
            this.selectedForUpdateVoting = [];
            this.$vs.notify({
              color: "success",
              text: "Candidates updated successfully!!",
              position: "top-center"
            });
          })
          .catch(error => {
            // Error response
            this.$vs.notify({
              title: "Failed to upload candidates",
              text: error,
              color: "danger",
              position: "top-center"
            });
            return false;
          });
      } else {
        return false;
      }
    },
    async loadVotingDetails() {
      this.$vs.loading();
      try {
        const res = await this.$store.dispatch("getEventVoting", this.votingSelected);
        this.votingSelectDisabled = true;
        this.showEditForm = true;

        const timer = res.data.data.timer ? res.data.data.timer.split(':') : ['00', '00'];

        delete res.data.data.timer;
        const editVotingArray = Object.assign({
          timer_: {
            minutes: timer[0],
            seconds: timer[1]
          }
        }, res.data.data);
        Object.defineProperty(editVotingArray, 'timer', {
          get() {
            return this.timer_.minutes + ':' + this.timer_.seconds
          }
        });
        this.editVotingArray = editVotingArray;
        
        this.candidatesInt = editVotingArray.candidates.length;
      }catch(error) {
        // Error response
        this.$vs.notify({
          title: "Failed to create voting, please try again",
          text: error,
          color: "danger",
          position: "top-center"
        });
      }
      this.$vs.loading.close()
    },

    resetAddForm() {
      this.votingData = [];
      this.votingArray = {
				event_id: "",
				voting_name: "",
				voting_description: "",
				voting_start_date: "",
				voting_end_date: "",
				opening_mode: "manual",
				type_of_voting: "1",
				quorum_type: "1",
				is_secret: "0",
				candidate_number: 1,
				preference_no: 1,
				number_of_candidates_elect: 1,
				option_number: 2,
				candidates: [
					{
						candidate_name: '',
						candidate_surname: '',
						is_checkbox: 0,
            is_button: false,
					}
				],
				timer_: {
					minutes: '00',
					seconds: '00'
				},
				get timer() {
					return this.timer_.minutes + ':' + this.timer_.seconds
				},
				options: [
          [{options: '', is_enabled: true},{options: '', is_enabled: true}]
        ]
    	};
    },
    resetEditForm() {
      this.updateVotingData = [];
      this.votingSelectDisabled = false;
      this.votingSelected = '';
      this.showEditForm = false;
      /* this.editVotingArray = {
        id: "",
        voting_name: "",
        voting_description: "",
        voting_start_date: "",
        voting_end_date: "",
        opening_mode: "manual",
        type_of_voting: "1",
        quorum_type: "1" ,
        is_secret: "0",
        candidate_number:1,
        preference_no:1,
        number_of_candidates_elect: 1,
        candidates : {
            '1': {
              'id': '',
              'candidate_name' : '',
            },
          },
      };*/
    },

    async updateVoting() {
      const result = await this.validators.$editVote.validateAll('voting-form');

      if(!result) 
        return false;

      this.$vs.loading();

      try{
        await this.$store.dispatch("updateNewVoting", Object.assign({timer: this.editVotingArray.timer}, this.editVotingArray))
        this.$vs.notify({
          color: "success",
          text: "Voting updated successfully!!",
          position: "top-center"
        });
        this.handleVotingInvite(this.selectedForUpdateVoting, this.editVotingArray.id);
        // this.handleVotingCandidates(this.selectedForUpdateCandidates, this.editVotingArray.id);
        this.resetEditForm();
      }catch(error) {
        // Error response
        this.$vs.notify({
          title: "Failed to create voting, please try again",
          text: error,
          color: "danger",
          position: "top-center"
        });
      }
      this.$vs.loading.close();
    },

    handleAddVotingInvite(voting_id) {
      if (this.selectedForVoting.length > 0) {

        this.selectedForVoting.forEach((element, index) => {
					element['email'] = element['Email'];
          element['first_name'] = element['First Name'];
          element['last_name'] = element['Last Name'];
          element['id_number'] = element['Id Number'];
          element['mobile_number'] = element['Mobile Number'];
          element['weight'] = element['Weight'] ? element['Weight'] : element['Right To Vote'];
          element['delegated_for'] = element['Delegated For'] ? element['Delegated For'] : null;
          element['is_moderator'] = element['Moderator'] ? element['Moderator'] : 0;
          element['is_speaker'] = element['Speaker'] ? element['Speaker'] : 0;
          element['external_id'] = element['External Id'] ? element['External Id'] : null;
          this.selectedForVoting[index] = element;
        });

        var data = {
          event_id: this.event_id,
          users: this.selectedForVoting,
          voting_id: voting_id
        };
        this.$vs.loading()
        this.$store
          .dispatch("importUsers", data)
          .then(() => {
            this.$vs.loading.close()
            this.selectedForVoting = []
            this.$vs.notify({
              color: "success",
              text: "Invitation sent successfully!!",
              position: "top-center"
            });
          })
          .catch(error => {
            this.$vs.loading.close()
            // Error response
            this.$vs.notify({
              title: "Failed to send invitation, please try again",
              text: error,
              color: "danger",
              position: "top-center"
            });
            return false;
          });
      } else {
        return false;
      }
    },
    exportToExcel() {
      import('@/utils/Export2Excel').then(excel => {
        const list = this.exportInvitees
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    selectAttendants(s) {
      if(s=='all')
        this.users = this.users.map(user => ({...user, selected: this.selectAllAttendants}))
      else {
        this.selectAllAttendants = this.users.every(user => user.selected)
      }
    }
  }
};
</script>
<style lang="scss">
.vx-card__actions {
  display: none;
}

.vx-card__header {
  display: none;
}

.vx-card__body {
  padding-top: 0 !important;
}

.vx-card {
  border-radius: 0;
  box-shadow: 0px 25px 25px 0px rgba(0, 0, 0, 0.1) !important;
}

.nexteventheader_div {
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1) !important;
}

.attendBtn {
  font-size: 10px;
  margin-bottom: 10px;
}

.vs-tabs--content {
  padding-left: 0 !important;
}

.eventSmsEmailBlock {
  margin-top: 30px;
}

.eventSmsEmailBlock input {
  margin-bottom: 20px;
}

.updateConfigBtn {
  padding: 0.70rem 1.5rem !important;
  margin: 4px !important;
}
</style>
